import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import Axios from './utils/Axios'
import reportWebVitals from "./reportWebVitals";

// call axios in index will provide access to our whole app to get or send data with API requests
Axios();
ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
